export function parseAddressParts(address) {
  const match = address.match(/(\d+)(?:\/(\d+))?(?!.*\d)/);
  if (!match) return { main: 0, sub: null };

  return {
    main: parseInt(match[1], 10),
    sub: match[2] !== undefined ? parseInt(match[2], 10) : null,
  };
}

export function compareHouseAsc(a, b) {
  const aParts = parseAddressParts(a.ulice);
  const bParts = parseAddressParts(b.ulice);

  if (aParts.main !== bParts.main) return aParts.main - bParts.main;
  if (aParts.sub === null && bParts.sub !== null) return -1;
  if (aParts.sub !== null && bParts.sub === null) return 1;
  if (aParts.sub !== null && bParts.sub !== null)
    return aParts.sub - bParts.sub;
  return 0;
}

export function compareHouseDesc(a, b) {
  return compareHouseAsc(b, a);
}
